<template>
    <div class="login">
        <div class="from-menu">
            <h1>扬天维修管理系统</h1>
            <div class="inp-menu user">
                <input
                    v-model="loginForm.username"
                    type="text"
                    placeholder="请输入账户">
            </div>
            <div class="inp-menu pwd">
                <input
                    v-model="loginForm.password"
                    type="password"
                    placeholder="请输入密码">
            </div>
            <div class="inp-menu pwd">
                <input
                    v-model="loginForm.tenantcode"
                    type="text"
                    placeholder="请输入租户编码">
            </div>
            <Checkbox
                v-model="checked"
                class="checkedpwd"
                shape="square">记住密码</Checkbox>
            <button @click="goHome()">登录</button>
        </div>
    </div>
</template>

<script>
import { Checkbox, Toast } from 'vant'
const Base64 = require('js-base64').Base64

export default {
    name: 'Login',
    components: {
        Checkbox
    },
    data() {
        return {
            checked: false,
            loginForm: {
                username: null,
                password: null,
                tenantcode:null
            }
        }
    },
    created() {
        // 在页面加载时从cookie获取登录信息
        const username = this.getCookie('user')
        const password = Base64.decode(this.getCookie('password'))
        const tenantcode= this.getCookie('tenantcode')
        // 如果存在赋值给表单，并且将记住密码勾选
        if (username) {
            this.loginForm.username = username
            this.loginForm.password = password
            this.loginForm.tenantcode=tenantcode
            this.checked = true
        }
    },
    methods: {
    // 记住密码
        setUserInfo() {
            // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
            // 如果没有勾选，储存的信息为空
            if (this.checked) {
                this.setCookie('user', this.loginForm.username)
                // base64加密密码
                this.setCookie(
                    'password',
                    Base64.encode(this.loginForm.password)
                )
                this.setCookie('tenantcode', this.loginForm.tenantcode)
            } else {
                this.setCookie('user', '')
                this.setCookie('password', '')
            }
        },
        // 获取cookie
        getCookie: function(key) {
            if (document.cookie.length > 0) {
                var start = document.cookie.indexOf(key + '=')
                if (start !== -1) {
                    start = start + key.length + 1
                    var end = document.cookie.indexOf(';', start)
                    if (end === -1) end = document.cookie.length
                    return unescape(document.cookie.substring(start, end))
                }
            }
            return ''
        },
        // 保存cookie
        setCookie: function(key, value, expiredays) {
            var exdate = new Date()
            exdate.setDate(exdate.getDate() + expiredays)
            var cooike = key +
                    '=' +
                    decodeURIComponent(value) +
                    (expiredays == null ? '' : ';expires=' + exdate.toGMTString())
            document.cookie = cooike
        },
        goHome() {
            // this.$router.push('/')
            if (!this.loginForm.username) {
                Toast.fail('请输入账号')
                return false
            }
            if (!this.loginForm.password) {
                Toast.fail('请输入密码')
                return false
            }
            const param = {
                username: this.loginForm.username,
                password: this.loginForm.password,
                tenantcode:this.loginForm.tenantcode
            }
            // this.$store.dispatch('user/login', param).then((res) => {
            this.$store.dispatch('user/login', param).then((res) => {
                if (res.code==200) {
                    console.log(res,'luyutong')
                    this.setUserInfo()
                    console.log(this.redirect,'this.redirect')
                    this.$router.push({ path: this.redirect || '/' })
                    // this.$router.push({ path: '/' })
                }
            }).catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>

<style lang='scss' scoped>
.login{
  width: 100%;
  min-height: 100vh;
  padding: 40% 0 81%;
  background-color: #fff;
  .checkedpwd{
    padding: 20px 0;
  }
  .from-menu{
    padding: 0 46px;
    padding-bottom: 55px;
    h1{
      margin-top: 80px;
      text-align: center;
      font-size: 56px;
      font-weight: 600;
    }
    .user{
      padding-top: 20px;
    }
    .inp-menu{
      height: 62px;
      width: 100%;
      margin-top: 60px;
      input{
        width: 100%;
        height: 52px;
        color: #9B9B9B;
        font-size: 32px;
        line-height: 52px;
        border-bottom: 1px solid #DCDCDC;
      }
    }
    button{
      width: 100%;
      height:86px;
      margin-top: 40px;
      background:#3498db;
      border-radius:50px;
      font-size: 32px;
      color: #fff;
    }
  }
}
</style>
